import classNames from 'classnames';
import Icon from 'components/styleguide/icon/Icon';
import React from 'react';

const styles = require('./MicroButton.module.scss');

export type MicroButtonContext = 'neutral' | 'talent' | 'company';

export interface MicroButtonProps {
  'aria-label': string;
  className?: string;
  context?: MicroButtonContext;
  iconName: string;
  onClick?: () => void;
}

const MicroButton: React.FC<MicroButtonProps> = ({
  'aria-label': ariaLabel,
  className,
  context = 'neutral',
  iconName,
  onClick,
}) => (
  <button
    type="button"
    className={classNames(styles.button, styles[context], className)}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    <Icon name={iconName} size="xs" color="neutral-border-white" aria-hidden="true" />
  </button>
);

export default MicroButton;
